export type CasasDecimais = 0 | 2 | 6;

const SOMENTE_NUMERO = /^[\d.,]*$/;

export function normalizarDigitacao(texto: string, casas: CasasDecimais): string | null {
  const limpo = texto.trim();
  if (!SOMENTE_NUMERO.test(limpo)) return null;

  let inteiro: string;
  let fracao: string | null = null;

  if (limpo.includes(",")) {
    const partes = limpo.split(",");
    if (partes.length > 2) return null;
    inteiro = (partes[0] ?? "").replaceAll(".", "");
    fracao = partes[1] ?? "";
    if (fracao.includes(".")) return null;
  } else {
    const partes = limpo.split(".");
    const ultima = partes[partes.length - 1] ?? "";
    if (partes.length === 2 && ultima.length <= casas) {
      inteiro = partes[0] ?? "";
      fracao = ultima;
    } else {
      inteiro = partes.join("");
    }
  }

  if (fracao !== null && fracao.length > casas) return null;
  if (!Number.isSafeInteger(Number(inteiro || "0"))) return null;

  return fracao === null ? inteiro : `${inteiro},${fracao}`;
}

export function lerNumero(texto: string): number | null {
  if (!/\d/.test(texto)) return null;
  const numero = Number(texto.replace(",", "."));
  return Number.isFinite(numero) ? numero : null;
}

export function formatarNumero(valor: number, casas: CasasDecimais): string {
  return valor.toLocaleString("pt-BR", {
    minimumFractionDigits: casas,
    maximumFractionDigits: casas,
  });
}
